/* tslint:disable */
/* eslint-disable */
/**
 * DAM PORTAL API
 * API for handling DAM PORTAL operations.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Asset,
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
} from './Asset';
import {
    AssetSearchRequest,
    AssetSearchRequestFromJSON,
    AssetSearchRequestFromJSONTyped,
    AssetSearchRequestToJSON,
} from './AssetSearchRequest';
import {
    FieldFacets,
    FieldFacetsFromJSON,
    FieldFacetsFromJSONTyped,
    FieldFacetsToJSON,
} from './FieldFacets';
import {
    Navigation,
    NavigationFromJSON,
    NavigationFromJSONTyped,
    NavigationToJSON,
} from './Navigation';

/**
 * Response for asset search request
 * @export
 * @interface AssetSearchResponse
 */
export interface AssetSearchResponse {
    /**
     * List of assets
     * @type {Array<Asset>}
     * @memberof AssetSearchResponse
     */
    result: Array<Asset>;
    /**
     * Facets for the current search request
     * @type {Array<FieldFacets>}
     * @memberof AssetSearchResponse
     */
    facets: Array<FieldFacets>;
    /**
     * 
     * @type {Navigation}
     * @memberof AssetSearchResponse
     */
    navigation?: Navigation;
    /**
     * Assets found
     * @type {number}
     * @memberof AssetSearchResponse
     */
    count?: number;
    /**
     * List of available pages
     * @type {number}
     * @memberof AssetSearchResponse
     */
    maxPages?: number;
    /**
     * 
     * @type {AssetSearchRequest}
     * @memberof AssetSearchResponse
     */
    request: AssetSearchRequest;
}

export function AssetSearchResponseFromJSON(json: any): AssetSearchResponse {
    return AssetSearchResponseFromJSONTyped(json, false);
}

export function AssetSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': ((json['result'] as Array<any>).map(AssetFromJSON)),
        'facets': ((json['facets'] as Array<any>).map(FieldFacetsFromJSON)),
        'navigation': !exists(json, 'navigation') ? undefined : NavigationFromJSON(json['navigation']),
        'count': !exists(json, 'count') ? undefined : json['count'],
        'maxPages': !exists(json, 'maxPages') ? undefined : json['maxPages'],
        'request': AssetSearchRequestFromJSON(json['request']),
    };
}

export function AssetSearchResponseToJSON(value?: AssetSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ((value.result as Array<any>).map(AssetToJSON)),
        'facets': ((value.facets as Array<any>).map(FieldFacetsToJSON)),
        'navigation': NavigationToJSON(value.navigation),
        'count': value.count,
        'maxPages': value.maxPages,
        'request': AssetSearchRequestToJSON(value.request),
    };
}

